<template>
  <v-container
    fluid
    v-if="businessProfile.plan == 'evolve' || events.length > 0"
  >
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="d-flex justify-space-between">
            <div class="text-h5">EventConnect</div>
            <div class="text-body-2 grey--text">
              <v-tooltip bottom close-delay="500">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" @click="showMCVideo = true">
                    <v-icon small color="grey lighten-1" class="cursor-pointer"
                      >mdi-help-circle-outline</v-icon
                    >
                    See how it works
                  </div>
                </template>
                <span class="cursor-pointer" @click="showMCVideo = true"
                  >Watch video</span
                >
              </v-tooltip>
            </div>
          </v-card-title>
          <v-card-subtitle>
            <!-- Total connections:
            <span class="font-weight-bold"> {{ totalNoOfConnections }}</span> -->
            <!-- <v-btn @click="handleRunCloudFunction">Run cloud function 1</v-btn>

            <v-btn @click="handleRunCloudFunction2">Run cloud function 2</v-btn> -->

            <!-- <v-btn @click="handleRunCloudFunction3"
              >Business profile admin list</v-btn
            > -->
          </v-card-subtitle>
          <v-card-text>
            <v-row class="mt-3">
              <v-col cols="4" md="3">
                <MetricCard
                  title="Total Events"
                  :value="totalEvents"
                  image="meeting-room.svg"
                />
              </v-col>
              <v-col cols="4" md="3">
                <MetricCard
                  title="Total Registrants"
                  :value="totalRegistrants"
                  image="team-leader.svg"
                />
              </v-col>
              <v-col cols="4" md="3">
                <MetricCard
                  title="Total Connections"
                  :value="totalConnections"
                  image="social-media.svg"
                />
              </v-col>
              <v-col cols="4" md="3">
                <MetricCard
                  title="Active/Upcoming Events"
                  :value="totalActiveOrUpcomingEvents"
                  image="events.svg"
                />
              </v-col>
              <v-col cols="12">
                <MultiConnectTable
                  :multiConnectEvents="events"
                  :hideCreateNewEventButton="businessProfile.plan != 'evolve'"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <MultiConnectVideo :show="showMCVideo" @close="showMCVideo = false" />
  </v-container>
  <MultiConnectOptIn v-else />
</template>

<script>
import MultiConnectTable from "@/components/MultiConnect/MultiConnectTable";
import MultiConnectVideo from "@/components/MultiConnect/MultiConnectVideo";
import MultiConnectOptIn from "@/components/MultiConnect/MultiConnectOptIn";
import { mapGetters } from "vuex";
import MetricCard from "@/components/SuperUser/MetricCard";
import {
  getBusinessProfilesCollection,
  getQueryBusinessPortalAccessCollection, getQueryUsersCollection,
  getUsersCollection
} from "@/shared/firebase_utils";
import {limit, where} from "firebase/firestore";


export default {
  components: {
    MultiConnectTable,
    MultiConnectVideo,
    MultiConnectOptIn,
    MetricCard,
  },
  computed: {
    ...mapGetters([
      "multiConnectEvents",
      "allMultiConnectEvents",
      "isSuperUser",
      "userProfile",
      "totalNoOfConnections",
      "businessProfile",
    ]),
    totalEvents() {
      return this.events?.length || 0;
    },
    totalRegistrants() {
      let totalRegistrants = 0;
      this.events.forEach((event) => {
        event.attendees.forEach((attendee) => {
          if (attendee.uid && attendee.businessCardId) totalRegistrants += 1;
        });
      });
      return totalRegistrants;
    },
    totalConnections() {
      let totalConnections = 0;
      this.events.forEach((event) => {
        if (event.noOfConnections != undefined)
          totalConnections += event.noOfConnections;
      });
      return totalConnections;
    },
    totalActiveOrUpcomingEvents() {
      let totalActiveOrUpcomingEvents = 0;
      this.events.forEach((event) => {
        if (event.getStatus() != "Past") {
          totalActiveOrUpcomingEvents++;
        }
      });
      return totalActiveOrUpcomingEvents;
    },
  },
  data() {
    return {
      events: [],
      showMCVideo: false,
    };
  },
  created() {
    this.initMultiConnectEvents();
  },
  watch: {
    allMultiConnectEvents: function () {
      this.initMultiConnectEvents();
    },
    multiConnectEvents: function () {
      this.initMultiConnectEvents();
    },
  },
  methods: {
    initMultiConnectEvents() {
      if (this.isSuperUser) {
        this.events = this.allMultiConnectEvents.filter((event) => {
          return event.businessProfileId == this.userProfile.businessProfileId;
        });
      } else this.events = this.multiConnectEvents;
    },
    async handleRunCloudFunction() {
      console.log("starting execution...");
      try {
        let businessProfilesSnapshot = await getBusinessProfilesCollection();

        let businessProfiles = businessProfilesSnapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() };
        });

        // console.log("businessProfiles: ", businessProfiles);

        let csvData = [];

        for (const businessProfile of businessProfiles) {
          let MULTICONNECT_ADD_ON =
            businessProfile.plan == "evolve" ? true : false;

          let adminsSnapshot = await getQueryBusinessPortalAccessCollection(
              where("businessProfileId", "==", businessProfile.id),
              where("privilegeLevel", "==", "admin"),
          );
          let admins = adminsSnapshot.docs.map((doc) => {
            return { id: doc.id, ...doc.data() };
          });
          // console.log("admins: ", admins);
          admins.forEach((admin) => {
            csvData.push({
              email: admin.email,
              MULTICONNECT_ADD_ON: MULTICONNECT_ADD_ON,
              firstName: admin.firstName,
              lastName: admin.lastName,
              id: admin.id,
              businessProfileId: admin.businessProfileId,
              businessName: admin.businessName,
            });
          });
        }

        console.log("csvData: ", csvData);

        let csvFile = "";

        csvData.forEach((item) => {
          csvFile += item.email + ", " + item.MULTICONNECT_ADD_ON;
          csvFile += "\n";
          // console.log("csvFile: ", csvFile);
        });

        console.log("csvFile: ", csvFile);

        // let refinedData = [];
        // businessProfiles.forEach((businessProfile) => {
        //   let rowData =
        //     businessProfile.businessName + " " + businessProfile.plan;
        //   refinedData.push(rowData);
        // });

        // let csvContent = "";

        // refinedData.forEach((row) => {
        //   csvContent += row.join(",") + "\n";
        // });

        // console.log("refinedData: ", refinedData);

        // const blob = new Blob([csvContent], {
        //   type: "text/csv;charset=utf-8,",
        // });
        // const objUrl = URL.createObjectURL(blob);
        // console.log("objUrl: ", objUrl);
      } catch (error) {
        console.log("Error occurred while creating CSV: ", error);
      }
    },
    async handleRunCloudFunction2() {
      console.log("starting execution...");
      try {
        let userProfilesSnapshot = await getUsersCollection();

        let users = userProfilesSnapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() };
        });

        console.log("users: ", users);

        let csvFile = "";

        for (const user of users) {
          if (user.signupType != undefined && user.signupType != "") {
            let SOURCE;
            if (user.signupType == "GENERAL_REGISTRATION")
              SOURCE = "GENERAL_REGISTRATION";
            else if (user.signupType == "REGISTRATION_BY_MULTI_CONNECT")
              SOURCE = "REGISTRATION_BY_MULTI_CONNECT";
            else if (user.signupType == "REGISTRATION_BY_PAID_CARD_SHARED")
              SOURCE = "REGISTRATION_BY_PAID_CARD_SHARED";
            else SOURCE = "REGISTRATION_BY_BASIC_CARD_SHARED";

            csvFile += user.email + ", " + SOURCE;
            csvFile += "\n";
            // console.log("csvFile: ", csvFile);
          }
        }
        console.log("csvFile: ", csvFile);
      } catch (error) {
        console.log("Error occurred while creating CSV: ", error);
      }
    },
    async handleRunCloudFunction3() {
      console.log("starting execution...");
      try {
        let userProfilesSnapshot = await getQueryUsersCollection(limit(20));

        let users = userProfilesSnapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() };
        });

        console.log("users: ", users);

        let csvFile = "";

        for (const user of users) {
          if (user.signupType != undefined && user.signupType != "") {
            let SOURCE;
            if (user.signupType == "GENERAL_REGISTRATION")
              SOURCE = "GENERAL_REGISTRATION";
            else if (user.signupType == "REGISTRATION_BY_MULTI_CONNECT")
              SOURCE = "REGISTRATION_BY_MULTI_CONNECT";
            else if (user.signupType == "REGISTRATION_BY_PAID_CARD_SHARED")
              SOURCE = "REGISTRATION_BY_PAID_CARD_SHARED";
            else SOURCE = "REGISTRATION_BY_BASIC_CARD_SHARED";

            csvFile += user.email + ", " + SOURCE;
            csvFile += "\n";
            // console.log("csvFile: ", csvFile);
          }
        }
        console.log("csvFile: ", csvFile);
      } catch (error) {
        console.log("Error occurred while creating CSV: ", error);
      }
    },
  },
};
</script>

<style scoped>
.v-tooltip__content {
  pointer-events: initial;
}
</style>